import styled from 'styled-components';

const EBarBoardOfProfessionalsResultDiv = styled.div`
  width: 100%;
`;

EBarBoardOfProfessionalsResultDiv.displayName = 'EBarBoardOfProfessionalsResultDiv';

export default EBarBoardOfProfessionalsResultDiv;
